import { useEffect } from "react";
import { sessionRecordingChoice, type SessionRecordingChoice } from "_shared/session-recording/session-recording-choice";
import { useSession } from "users/__session/session-context";

/**
 * Tells the session recording choice whether the session restored at boot is signed in.
 *
 * The sign-ins and sign-outs that follow arrive as session events the choice listens to itself;
 * this covers the one moment no event marks, a page loaded with a session already in storage.
 *
 * Called at the router's root, so recording and the footer's Cookie preferences follow the sign-in
 * on every page — not only inside the shell, where the banner is.
 */
export function useSessionRecordingFollowsSignIn(choice: SessionRecordingChoice = sessionRecordingChoice): void {
  const isSignedIn = useSession().isLoggedIn;

  useEffect(() => {
    choice.setSignedIn(isSignedIn);
  }, [choice, isSignedIn]);
}
